
export interface EnrollmentProgress {
  /**
   * 완료한 레슨 수
   * @minimum 0
   */
  completedLessons: number;
  /**
   * 완료한 모듈 수
   * @minimum 0
   */
  completedModules: number;
  /**
   * 예상 완료 일자
   * @nullable
   */
  estimatedCompletionDate?: string | null;
  /**
   * 최종 점수
   * @minimum 0
   * @maximum 100
   * @nullable
   */
  finalScore?: number | null;
  /**
   * 마지막 접근 일시
   * @nullable
   */
  lastAccessedAt?: string | null;
  /**
   * 진행률 (%)
   * @minimum 0
   * @maximum 100
   */
  percentage: number;
  /**
   * 전체 레슨 수
   * @minimum 0
   */
  totalLessons: number;
  /**
   * 전체 모듈 수
   * @minimum 0
   */
  totalModules: number;
}
